import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Solicitud } from '../models/t2_solicitud.model';
import { SolicitudesService } from '../services/solicitudes.service';

@Component({
  selector: 'app-web',
  imports: [FormsModule, CommonModule],
  templateUrl: './web.component.html',
  styleUrl: './web.component.css'
})
export class WebComponent {
  solicitud: Solicitud = new Solicitud();
  solicitudGenerada: Solicitud = new Solicitud();
  isSubmitting: boolean = false;
  submitMessage: string = '';
  submitSuccess: boolean = false;

  generado: boolean = false;
  mensaje: boolean = false;
  btn: boolean = true;

  constructor(private service: SolicitudesService) {
    this.generarNumeroRegistro();
  }

  ngOnInit(): void {
    this.generado = false;
    this.mensaje = false;
  }

  // Generar número de registro automático
  generarNumeroRegistro(): void {
    const fecha = new Date();
    const año = fecha.getFullYear();
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const dia = fecha.getDate().toString().padStart(2, '0');
    const hora = fecha.getHours().toString().padStart(2, '0');
    const minuto = fecha.getMinutes().toString().padStart(2, '0');
    const segundo = fecha.getSeconds().toString().padStart(2, '0');
    
    this.solicitud.t2_numero_registro = `UNCP-${año}${mes}${dia}-${hora}${minuto}${segundo}`;
  }

  // Validar formulario
  validarFormulario(): boolean {
    if (!this.solicitud.t2_apellidos_nombres.trim()) {
      this.mostrarMensaje('Por favor, ingrese apellidos y nombres', false);
      this.mensaje = true;
      return false;
    }

    if (!this.solicitud.t2_numero_documento.trim()) {
      this.mostrarMensaje('Por favor, ingrese el número de documento', false);
      this.mensaje = true;
      return false;
    }

    if (!this.solicitud.t2_informacion_solicitada.trim()) {
      this.mostrarMensaje('Por favor, describa la información solicitada', false);
      this.mensaje = true;
      return false;
    }

    // Validar que al menos una forma de entrega esté seleccionada
    const formasEntrega = [
      this.solicitud.t2_entrega_copia_simple,
      this.solicitud.t2_entrega_diskette,
      this.solicitud.t2_entrega_cd,
      this.solicitud.t2_entrega_correo_electronico,
      this.solicitud.t2_entrega_otro
    ];

    if (!formasEntrega.some(forma => forma === true)) {
      this.mostrarMensaje('Por favor, seleccione al menos una forma de entrega', false);
      this.mensaje = true;
      return false;
    }

    // Si selecciona "Otro", debe especificar
    if (this.solicitud.t2_entrega_otro && !this.solicitud.t2_entrega_otro_especificar.trim()) {
      this.mostrarMensaje('Por favor, especifique la otra forma de entrega', false);
      this.mensaje = true;
      return false;
    }

    // Validar correo electrónico si se proporciona
    if (this.solicitud.t2_correo_electronico && !this.validarEmail(this.solicitud.t2_correo_electronico)) {
      this.mostrarMensaje('Por favor, ingrese un correo electrónico válido', false);
      this.mensaje = true;
      return false;
    }

    return true;
  }

  // Validar formato de email
  validarEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Enviar formulario
  async enviarFormulario(): Promise<void> {
    console.log('Enviando formulario...', this.solicitud);

    if (!this.validarFormulario()) {
      return;
    }

    console.log('Formulario validado correctamente.');

    this.generado = false;
    this.mensaje = false;
    this.btn = false;

    this.isSubmitting = true;
    this.submitMessage = 'Generando cargo...';

    try {
      // Actualizar metadatos
      //this.solicitud.t2_fecha_creacion = new Date();
      //this.solicitud.t2_usuario_creacion = 'WEB_USER'; // O el usuario logueado

      // Simular envío (aquí iría la llamada al servicio)
      await this.service.postData(this.solicitud).subscribe(
        response => {
          this.btn = true;
          if(response.insertId) {
            this.solicitudGenerada = this.solicitud;
            this.solicitudGenerada.t2_id = response.insertId;
            console.log('Solicitud enviada exitosamente:', response);
            this.generado = true;
            this.mensaje = true;
            this.mostrarMensaje('Cargo generado exitosamente.', true);
            this.solicitud = new Solicitud();
          }
        },
        error => {
          this.btn = true;
          this.mensaje = true;
          console.error('Error al enviar solicitud:', error);
          this.mostrarMensaje('Error al enviar la solicitud. Por favor, inténtelo nuevamente.' + error.error, false);
        }
      );
      
      // Opcional: resetear formulario después del envío exitoso
      // this.resetearFormulario();

    } catch (error: any) {
      this.btn = true;
      this.mensaje = true;
      console.error('Error al enviar solicitud:', error);
      this.mostrarMensaje('Error al enviar la solicitud. Por favor, inténtelo nuevamente.' + error.error, false);
    } finally {
      this.btn = true;
      this.isSubmitting = false;
    }
  }


  // Resetear formulario
  resetearFormulario(): void {
    if (confirm('¿Está seguro de que desea limpiar todos los campos del formulario?')) {
      this.solicitud = new Solicitud();
      this.solicitudGenerada = new Solicitud();
      this.generarNumeroRegistro();
      this.submitMessage = '';
      this.submitSuccess = false;
      this.generado = false;
      this.mensaje = false;
      this.mostrarMensaje('Formulario limpiado correctamente', true);
    }
  }

  // Mostrar mensaje
  private mostrarMensaje(mensaje: string, esExito: boolean): void {
    this.submitMessage = mensaje;
    this.submitSuccess = esExito;
  }

  // Descargar formulario
  descargarFormulario(): void {
    this.btn = false;
    //console.log(this.movimiento_find);
    this.service.descargarData(this.solicitudGenerada).subscribe(
        res => {
          // Crear un objeto URL para el blob
          const blob = new Blob([res], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          // Abrir el PDF en una nueva pestaña
          window.open(url);
          // Liberar la URL del objeto cuando ya no se necesita
          window.URL.revokeObjectURL(url);
          this.btn = true;
        },
        error => {
          console.log(error);
          this.btn = true;
        }
    );
  }

  // Manejar cambio en checkbox "Otro"
  onOtroChange(): void {
    if (!this.solicitud.t2_entrega_otro) {
      this.solicitud.t2_entrega_otro_especificar = '';
    }
  }



}
